import * as types from './mutation-types'
import Vue  from 'vue'
import axios from 'axios'
import { MutationTree } from 'vuex/types'
import { IDebugState } from './state'
import { DebugItem } from '@/models/ui/DebugItem'

const mutations: MutationTree<IDebugState> = {
  [types.DEBUG_ADD_ITEMS]: (state, item:DebugItem) => {
    state.items.push(item)
  },
  [types.DEBUG_TOGGLE_STATE]: state => {
    state.debugEnable = !state.debugEnable
  },
  [types.DEBUG_UPDATE_FILTER]: (state, newProperties:Object) => {        
    state.debugFilter = {...state.debugFilter,...newProperties}
  },
}

export default mutations
